// *******************************************************
// Eggs Export File
// -------------------------------------------------------

// *******************************************
// Exports
// -------------------------------------------
export {default as Stock} from './Stock';
export {default as Single} from './Single';
// --------------------------------



// WEBPACK FOOTER //
// ./src/components/Food/Cupcake/index.js